import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import 'leaflet/dist/leaflet.css'
// 引入响应式适配工具
import { initResponsive } from './utils/responsive'

// 初始化响应式适配（必须在挂载前执行）
initResponsive()

const app = createApp(App)
app.use(router)
app.mount('#app')